import { Injectable, inject } from '@angular/core';
import { Dialog } from '@angular/cdk/dialog';
import { LandRoleDialogComponent } from './land-role-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { loadLandRole } from '@frontend/data-access-land-role';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root',
})
export class LandRoleDialogService {
  private dialog = inject(Dialog);
  private store = inject(Store);
  private translate = inject(TranslateService);

  openLandRoleDialog(countryId?: string | null, roleId?: string | null) {
    this.store.dispatch(loadLandRole({ language: this.translate.currentLang }));

    const isMobile = window.innerWidth <= 768;

    this.dialog.open(LandRoleDialogComponent, {
      width: isMobile ? '100vw' : undefined,
      maxWidth: isMobile ? '100vw' : '800px',
      minWidth: isMobile ? '100vw' : '600px',
      height: isMobile ? '100vh' : undefined,
      panelClass: isMobile ? 'land-role-dialog-mobile' : undefined,
      data: {
        preselectedCountryId: countryId,
        preselectedRoleId: roleId,
      },
    });
  }
}
